import useFetch from '@hooks/useFetch';
import { processBatchDataFromAPI } from '@api/processors/batch';

export const getKey = (batchUID) => `v3/batch/${batchUID}/details/`;
export const getBatchUserKey = (batchUID) => `v1/batch/${batchUID}/users-info/`;

const useBatchDetails = (batchUID) => {
  const key = getKey(batchUID);
  const userKey = getBatchUserKey(batchUID);

  const { data: batchDetails } = useFetch(batchUID ? key : null);
  const { data: batchUserDetails, ...rest } = useFetch(
    batchUID ? userKey : null
  );
  const combinedBatchData = {
    batchDetails: processBatchDataFromAPI({
      ...batchDetails,
      ...batchUserDetails
    })
  };
  return {
    key,
    batchDetails: combinedBatchData?.batchDetails,
    ...rest
  };
};

export default useBatchDetails;
